import { EnumProcessState } from './Generated';
import type { SelectOption, BadgeVariations } from '@synqo/frontend-component-library';

export const getEnumProcessStateLabel = (value: EnumProcessState) => {
    switch (value) {
        case EnumProcessState.Open:
            return 'Offen';
        case EnumProcessState.InProgress:
            return 'In Bearbeitung';
        case EnumProcessState.ExecutionFinished:
            return 'Erledigt';
        case EnumProcessState.Approved:
            return 'Freigegeben';
        case EnumProcessState.Completed:
            return 'Abgeschlossen';
        default:
            return 'Nicht definiert';
    }
};

export const getBadgeVariantByProcessState = (value: EnumProcessState): BadgeVariations => {
    switch (value) {
        case EnumProcessState.Open:
            return 'default';
        case EnumProcessState.InProgress:
            return 'warning';
        case EnumProcessState.Approved:
            return 'accent';
        case EnumProcessState.ExecutionFinished:
            return 'success';
        case EnumProcessState.Completed:
            return 'info';
        default:
            return 'danger';
    }
};

export function isApproved(state: EnumProcessState) {
    return state === EnumProcessState.Approved || state === EnumProcessState.Completed;
}

export function isCompleted(state: EnumProcessState) {
    return state === EnumProcessState.Completed;
}

export const processStateOptions: SelectOption<EnumProcessState>[] = [
    { name: 'open', label: getEnumProcessStateLabel(EnumProcessState.Open), value: EnumProcessState.Open },
    {
        name: 'in_progress',
        label: getEnumProcessStateLabel(EnumProcessState.InProgress),
        value: EnumProcessState.InProgress,
    },
    {
        name: 'finished',
        label: getEnumProcessStateLabel(EnumProcessState.ExecutionFinished),
        value: EnumProcessState.ExecutionFinished,
    },
    { name: 'approved', label: getEnumProcessStateLabel(EnumProcessState.Approved), value: EnumProcessState.Approved },
    {
        name: 'completed',
        label: getEnumProcessStateLabel(EnumProcessState.Completed),
        value: EnumProcessState.Completed,
    },
];
